import { LoadingButton, TextField } from '@carsys/ui'
import { useMutation } from '@cbgms/base/http/use-query'
import { Grid, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { copyShopAccountsAndVehicles } from '../state/actions'
import { useState } from 'react'
import { POSTCopyAccountsVehiclesRequest } from '@cbgms/api'
import { useNotifier } from '@cbgms/base/notifier'

interface CopyShopDataFormProps {
  companyUUID: string
  shopID: string
}

export function CopyShopDataForm({ companyUUID, shopID }: CopyShopDataFormProps) {
  const { t } = useTranslation()
  const [fromShopID, setFromShopID] = useState('')
  const notifier = useNotifier()
  const dispatch = useDispatch()
  const mutation = useMutation({
    mutationFn: (request: POSTCopyAccountsVehiclesRequest) => dispatch(copyShopAccountsAndVehicles(request)),
    onSuccess: () => notifier.success(t('shop.copy_shop_data_success')),
    onError: () => notifier.error(t('shop.copy_shop_data_error'))
  })

  return (
    <Grid container item spacing={1}>
      <Grid item xs={12}>
        <Typography variant='h5'>{t('shop.copy_shop_data')}</Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography>{t('shop.copy_shop_data_description')}</Typography>
      </Grid>
      <Grid item xs={2}>
        <TextField value={fromShopID} onChange={e => setFromShopID(e.target.value)} placeholder={t('shop.from_shop_id')} />
      </Grid>
      <Grid item xs={2}>
        <LoadingButton
          onClick={() => mutation.mutate({ ToCompanyUUID: companyUUID, ToShopID: shopID, FromShopID: fromShopID })}
          variant='outlined'
          disabled={!fromShopID}
          loading={mutation.isLoading}
        >
          {t('shop.copy_shop_data')}
        </LoadingButton>
      </Grid>
    </Grid>
  )
}
